import { useAuth } from '@/context/AuthContext';

export const useBusinessType = () => {
  const { selectedBusiness } = useAuth();
  const businessType = selectedBusiness?.business_type || 'aesthetic_training';
  const isTrainingCentre = businessType === 'aesthetic_training';
  return { businessType, isTrainingCentre };
};
